import { ROUTES_PROFILE_ATHLETE_LIST } from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

export default {
    path: '/profile-athlete-list',
    name: ROUTES_PROFILE_ATHLETE_LIST,
    beforeEnter: guardRouteProfileAthleteList,
    component: () => import(/*webpackChunkName: 'profile-athlete-list'*/ '@/views/profile/ProfileAthleteList')
};

function guardRouteProfileAthleteList(to, from, next) {
    const unauthorized =
        store.getters.isSelectedClubIndividual || !store.getters['userPermissions/canViewAthleteProfile'];
    guardRoute(next, unauthorized);
}
